import { call, put } from 'redux-saga/effects';
import { checkResponse } from 'store/utils';
import { fetchMetadataAttachmentsSuccess } from '../actions';
import {
  getTransactionAttachmentsByMetadata,
  TransactionAttachmentsResponse,
} from '../api';
import { TransactionAttachment } from '../models/transactionAttachments';
import { FetchMetadataAttachmentsRequestAction } from '../types';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* fetchMetadataAttachmentsSaga(
  action: FetchMetadataAttachmentsRequestAction
) {
  const { connectionId, metadataId, fileName } = action.payload;

  try {
    const response: TransactionAttachmentsResponse = yield call(
      getTransactionAttachmentsByMetadata,
      connectionId,
      metadataId
    );

    const err = checkResponse(response?.responseMessage);
    const attachments: TransactionAttachment[] = err
      ? []
      : response.data?.files ?? [];

    yield put(
      fetchMetadataAttachmentsSuccess(attachments, metadataId, fileName)
    );
  } catch {
    yield put(fetchMetadataAttachmentsSuccess([], metadataId, fileName));
  }
}
